import Destination from './Destination';
import DestinationCity from './DestinationCity';
import DestinationSearch from './DestinationSearch';

const ACTION = {
  ...Destination.ACTION,
  ...DestinationCity.ACTION,
  ...DestinationSearch.ACTION,
};

const ACTION_TYPES = {
  ...Destination.ACTION_TYPES,
  ...DestinationCity.ACTION_TYPES,
  ...DestinationSearch.ACTION_TYPES,
};

const Index = {
  ACTION,
  ACTION_TYPES
}

export default Index;